import './common/base';
import Vue from './vue/common/vue-common';
import RenderNotifier from './vue/components/common/RenderNotifier';
import VueMask from 'v-mask';
import SalesRepCartCustomerManager from './vue/components/sales-rep/SalesRepCartCustomerManager.vue';
import Advantages from './vue/components/common/Advantages.vue';
import ProductCredit from './vue/components/product/ProductCredit.vue';
import ProductAboutForWholesaler from './vue/components/product/ProductAboutForWholesaler.vue';
import ProductWholesalerSizesSummary from './vue/components/product/ProductWholesalerSizesSummary.vue';
import ProductWholesalerMultipleSizes from './vue/components/product/ProductWholesalerMultipleSizes.vue';
import ProductWholesalerSingleSize from './vue/components/product/ProductWholesalerSingleSize.vue';
import ProductCreatorOtherProducts from './vue/components/product/ProductCreatorOtherProducts.vue';
import CashbackFaq from './vue/components/cashback/CashbackFaq.vue';
import BasicsKit from './vue/components/product/BasicsKit.vue';
import Recommendations from './vue/components/common/Recommendations.vue';
import { updateLazyLoad } from '../../submodules/src/script/lazyload';
import product from '../../submodules/src/script/i18n/product';
import shop from '../../submodules/src/script/i18n/shop';
import marketing from '../../submodules/src/script/i18n/marketing';
import general from '../../submodules/src/script/i18n/general';
import locale from '../../submodules/src/script/i18n/locale';
import gallery from '../../submodules/src/script/i18n/gallery';
import ProductPage from '../../submodules/src/componentsV2/product/ProductPage.vue';

Vue.use(VueMask);

cr$.ready(function () {
    new Vue({
        el: '#product-vue',
        i18n: locale(general(), shop(), product(), gallery(), marketing()),
        data() {
            return {
                shirtsSliderOptions: {
                    slidesPerView: 2,
                    fitSlidesToParent: true,
                    onNavigate: () => updateLazyLoad(),
                    responsive: [
                        {
                            minWidth: 565,
                            settings: {
                                slidesPerView: 3,
                            },
                        },
                        {
                            minWidth: 960,
                            settings: {
                                slidesPerView: 5,
                            },
                        },
                    ],
                },
                recommendationsItemOptions: {
                    displayPercent: false,
                    hideInstallments: true,
                    hidePromoBadge: true,
                },
                recommendationsParams: {
                    scenario: 'product-page',
                    rotationRate: 0.1,
                    minRelevance: 'medium',
                    list: 'Recomendações página Produto ',
                    product_id: this.$scope.ELASTIC_PRODUCT.id,
                    impact_user: false,
                    ignore_products: this.relatedPartnerProductsIds,
                },
            };
        },
        computed: {
            relatedPartnerProductsIds() {
                if (
                    !this.$scope.ELASTIC_PRODUCT ||
                    !this.$scope.ELASTIC_PRODUCT.partner ||
                    !this.$scope.ELASTIC_PRODUCT.partner.other_products
                ) {
                    return '';
                }

                return this.$scope.ELASTIC_PRODUCT.partner.other_products
                    .map((p) => p.id)
                    .join(',');
            },
        },
        components: {
            'render-notifier': RenderNotifier,
            'product-page': ProductPage,
            'sales-rep-cart-customer-manager': SalesRepCartCustomerManager,
            'product-credit': ProductCredit,
            'product-about-for-wholesaler': ProductAboutForWholesaler,
            'product-wholesaler-single-size': ProductWholesalerSingleSize,
            'product-wholesaler-multiple-sizes': ProductWholesalerMultipleSizes,
            'product-wholesaler-sizes-summary': ProductWholesalerSizesSummary,
            'product-creator-other-products': ProductCreatorOtherProducts,
            'cashback-faq': CashbackFaq,
            'basics-kit': BasicsKit,
            recommendations: Recommendations,
            advantages: Advantages,
        },
    });
});
